//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmSpisovyPlan.ts						</Name>
//    <Description> Dialog seznam Spisov� pl�n										</Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-10                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.15.2
//AdtGeneratorConfig:[ T:(sslsspl) GID:(Web.Set.Ts) V1:(spis_pl,lic,aktivita,arw,poznamka,dat_od,dat_do,dat_zmena,zmenu_prov,nazev,popis,priz_vycet,oddelovace,prirustek,priz_num,priz_manual,priz_check_lev,root_level,priz_end_znak,ixs_tre,spis_pl_ext) V2:() K1:() K2:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

	/** dialog seznamu  */
	@gcontent
	export class SeznamAdmSpisovyPlan extends GContentBase<SeznamAdmSpisovyPlanDesigner>  {

		//#region *** onContentReady && Init ***

		/** onContentReady */
		public onContentReady(): void {
			this.init();
		}

		/** init content */
		private init() {

			// inicializace hodnot od rodice
			SeznamAdmSpisovyPlanDesigner.SeznamAdmSpisovyPlanDesignerInit(this, this.spis_pl);

			this.setTitle();
			this.createMenuButtons();
			this.createGrid();
			this.createMenuBar();
			this.createSidebar();
		}

		/** nastavit titulek dialogu */
		private setTitle() {
				this.title = "jres:29808065" 	//RC 29808065 : Spisov� pl�n
		}

		//#endregion

		//#region *** menubar ***

		private createContextBar(): MenuParams[] {
			var bar = this.setMenuButtons();
			return bar;
		}

		/**
		 * createMenuButtons
		 */
		private createMenuButtons(): void {
			this.novyZaznamButton();
			this.detailButton();
			this.createImportSpisPlan();
		}

		/**
		 * vytvo�it menu
		 */
		private createMenuBar(): void {
			this.menuBar(this.setMenuButtons());
		}

		private setMenuButtons(): MenuParams[] {

			const bar: MenuParams[] = [];

			bar.push({
				favorite: true,
				primary: true,
				action: this.actions.actNovy
			})

			bar.push({
				favorite: true,
				action: this.actions.actDetail
			})

			bar.push({
				favorite: true,
				action: this.actions.actImportSpisPlan
			})

			return bar;
		}

		private createImportSpisPlan() {
			this.actions.add(new GAction({
				name: "actImportSpisPlan",
				icon: "fa-upload",
				caption: "jres:33000033", //RC 33000033 : Import spisov�ho pl�nu
				run: (ev, ctx) => {
					this.dialogs.showModalWindow("Gordic.Adm.WebControls.SpisovyPlanImport", null, { height: 300, width: 700 });
				}
			}))
		}

		private novyZaznamButton() {
			this.actions.add(new GAction({
				name: "actNovy",
				icon: "gi-plus",
				caption: "jres:32000121",			//RC 32000121 : Nov� z�znam
				run: () => {
					var newRecord = true;
					this.openDetail(newRecord);
				}
			}));
		}

		/**
		 * detail button
		 */
		private detailButton(): void {
			this.actions.add(new GAction({
				name: "actDetail",
				icon: "gi-detail",
				caption: "jres:32131033",			//RC 32131033 : Detail
				run: () => {
					this.openDetail();
				}
			}));
		}


		//#endregion

		//#region *** detail ***

		/**
		 * otev��t detail
		 */
		private openDetail(_new?: boolean): void {

			var newRecord = _new == null ? false : _new;

			if (newRecord === true) {
				// nov� z�znam p�i pr�zdn�m gridu
				Dialogs.DetailAdmSpisovyPlanDlg(this, { spis_pl: this.spis_pl, grid: this.grid, newRecord: newRecord }).done((data: any) => { });
			}
			else if (Utils.isGridEmpty(this.grid)) {
				this.showFlash("jres:32131036", "g-state-warning", 2500, "id-flash-empty-grid-detail"); //RC 32131036 : Seznam je pr�zdn�, nelze p�ej�t na detail.
			}
			else {

				var selection = this.grid.ggrid("getSelection");

				// vybran� jeden ��dek
				if (selection.length === 1) {
					var data: any = selection[0];
					Dialogs.DetailAdmSpisovyPlanDlg(this, { spis_pl: data.spis_pl, grid: this.grid, newRecord: newRecord }).done((data: any) => { });
				}

				// vybr�no v�ce ��dk�
				else {
					this.showFlash("jres:32131037", "g-state-warning", 2500, "id-flash-select-more-rows-grid-detail"); //RC 32131037 : Nelze p�ej�t na detail s v�ce vybran�mi ��dky.
				}
			}

		}

		//#endregion

		//#region *** grid ***

		/** vytvo�it seznam - definice objektu GRIDu, nav�zan�ch ud�lost� atd... */
		private createGrid(): void {

			this.grid = $("<div>").gautofit().appendTo(this.element);

			this.grid.ggrid({
				data: this.view,
				name: "gridSeznam",
				dataKey: "spis_pl",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				defaultAction: new GAction({							//obsluzna akce, ktera se spousti dbl clickem nad radkem
					name: "doubleClickGridSeznam",
					run: (ev, ctx) => {
						this.openDetail();
					}
				}),
				searchColumns: this.gridSearchColumns,
				columns: this.gridFormat,
				contextMenu: this.createContextBar(),					// contextov� menu
				sort: "spis_pl",									    // �azen� seznamu 
				selection: (ev, obj) => {
					this.row = obj.getSelection();
					this.refreshPanel();
				}
			});

		}

		//#endregion

		//#region *** sidebar ***

		/** vytvo�it sidebar */
		private createSidebar() {
			this.removeSidebar();
			var panel = this.createPanel();
			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [panel]
				}
			});
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/**  vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahledSeznam";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
				leaf: "jres:32131038",								//RC 32131038 : N�hled
				icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel($(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		/** refresh panelu */
		private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.closed) {		// o�et�en� zav�en� contentu
				return;
			}

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}
			if (panel !== undefined) {
				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}
				this.panelElement = $("<div>").appendTo(panel);
				GridUtils.setPanelGrid("jres:32131039", this.row, this.gridFormat, this.panelElement); //RC 32131039 : Seznam
			}
		}

		//#endregion

	}

}